import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A1128]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img src="https://public.readdy.ai/ai/img_res/42ee9d89-5646-4cd0-bc98-3a78e4d86d67.png" alt="IMPORMANZ S A S" className="h-10 w-10 object-contain" />
            <span className="text-white font-bold text-xl tracking-tight">IMPORMANZ S A S</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('about')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              About
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('features')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              VPN Features
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              How It Works
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('support')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              Support
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-white/90 hover:text-[#00D9FF] transition-colors duration-300 relative group whitespace-nowrap">
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00D9FF] group-hover:w-full transition-all duration-300"></span>
            </button>
          </div>

          <button onClick={() => scrollToSection('contact')} className="hidden md:block bg-gradient-to-r from-[#00D9FF] to-[#8B5CF6] text-white px-6 py-2.5 rounded-full font-semibold hover:shadow-lg hover:shadow-[#00D9FF]/50 transition-all duration-300 whitespace-nowrap">
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
